import TrucksList from "./TrucksList";

export default TrucksList;
